/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Event_Aria_LabelInputs */

const en_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Selected Events`)
};

const fr_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les Evenements Selectionnes`)
};

const de_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse entfernen`)
};

const it_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi eventi selezionati`)
};

const ru_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранные события`)
};

const es_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar eventos seleccionados`)
};

const zh_cn2_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除选定事件`)
};

const ja_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを削除`)
};

const hi_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं को हटाएँ`)
};

const pt_pt2_remove_event_aria_label = /** @type {(inputs: Remove_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Remove Selected Events" |
*
* @param {Remove_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_event_aria_label = /** @type {((inputs?: Remove_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_event_aria_label(inputs)
	if (locale === "de") return de_remove_event_aria_label(inputs)
	if (locale === "it") return it_remove_event_aria_label(inputs)
	if (locale === "ru") return ru_remove_event_aria_label(inputs)
	if (locale === "es") return es_remove_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_event_aria_label(inputs)
	if (locale === "ja") return ja_remove_event_aria_label(inputs)
	if (locale === "hi") return hi_remove_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_event_aria_label(inputs)
	return en_remove_event_aria_label(inputs)
});